import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Button, View } from '@aws-amplify/ui-react';

const Separator = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    background-color: var(--bs-light); 

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50%;
        background-color: white;
        z-index: 0;
    }

    strong {
        z-index: 1;
        font-size: 1.25rem;
    }

    hr {
        flex-grow: 1;
        margin: 0 0.5rem;
        border: none;
        border-top: 1px solid var(--bs-dark);
    }
`;

const ActionsWrap = styled.div`
    padding: 1rem;
    background-color: var(--bs-light);

    @media (max-width: 576px) {
        padding: 0.75rem;
    }
`;


const ActionsRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 0.75rem;
    width: 100%;
    flex-direction: column;
    align-items: stretch;

    @media (min-width: 768px) {
        flex-direction: row;
        align-items: center;
    }
`;

const ActionButton = styled(Button)`
    background: white;
    border-radius: 15px;
    box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.12);
    width: 100%;
    max-width: 420px;
    white-space: normal;
    line-height: 1.2;

    @media (min-width: 768px) {
        width: auto;
        min-width: 220px;
        max-width: none;
    }

    @media (max-width: 576px) {
        border-radius: 12px;
    }
`;

export const LoginFooterUI = ({ onForgotPassword }) => {
    const navigate = useNavigate();

    return (
        <View textAlign="center">
            <div className="d-flex flex-column">
                <Button
                    className="mb-2"
                    fontWeight="normal"
                    onClick={onForgotPassword}
                    size="small"
                    variation="link"
                >
                    ¿Olvidó su contraseña?
                </Button>
                <Button
                    className="mb-2"
                    fontWeight="normal"
                    onClick={() => navigate('/credenciales')}
                    size="small"
                    variation="link"
                    title="Si tu contraseña temporal ha caducado o no encuentras el correo de bienvenida"
                >
                    ¿Contraseña temporal caducada? Solicitar credenciales nuevas
                </Button>

                <Separator>
                    <hr />
                    <strong>O regístrate</strong>
                    <hr />
                </Separator>

                <ActionsWrap>
                    <ActionsRow>
                        <ActionButton onClick={() => navigate('/registroclientes')}>
                            Soy cliente,<br />solicitar acceso web
                        </ActionButton>

                        <ActionButton onClick={() => navigate('/registro')}>
                            No soy cliente
                        </ActionButton>
                    </ActionsRow>
                </ActionsWrap>
            </div>
        </View>
    );
};
